import { gql } from 'apollo-angular';

export const ADS_LIST = gql`
query Ads($page: Int, $audience: String, $status: String) {
  ads(page: $page, audience: $audience, status: $status) {
    adsId
    audience
    dateCreated
    dateUpdated
    description
    isSponsor
    link
    photo
    publishedDate
    sponsor
    status
    subTitle
    title
  }
}
`;
